import { ArrowRight, Check, Circle } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type SummaryRow = { key: string; label: string; value: string; confirmed: boolean }

type Props = {
  rows: SummaryRow[]
  remaining: number
  busy: boolean
  onCreate: () => void
  createLabel: string
}

/** « Ce qui sera créé » — the whole result in four lines, and the one button that does it. */
export function WinnerReviewSummary({ rows, remaining, busy, onCreate, createLabel }: Props) {
  return (
    <aside className="space-y-4 rounded-xl border bg-background p-5 lg:sticky lg:top-6">
      <h3 className="font-semibold">Ce qui sera créé</h3>
      <ul className="space-y-3">
        {rows.map((row) => (
          <li key={row.key} className="flex items-start gap-3" data-testid={`winner-import-summary-${row.key}`}>
            <span
              className={cn(
                'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full',
                row.confirmed ? 'bg-emerald-500 text-white' : 'text-slate-300'
              )}
            >
              {row.confirmed ? <Check className="h-3 w-3" /> : <Circle className="h-4 w-4" />}
            </span>
            <span className="min-w-0">
              <span className="block text-xs uppercase tracking-wide text-muted-foreground">{row.label}</span>
              <span className="block break-words text-sm font-medium">{row.value}</span>
            </span>
          </li>
        ))}
      </ul>

      <Button
        size="lg"
        className="w-full gap-2"
        disabled={remaining > 0 || busy}
        onClick={onCreate}
        data-testid="winner-import-create-btn"
      >
        {createLabel}
        <ArrowRight className="h-4 w-4" />
      </Button>
      <p className="text-center text-xs text-muted-foreground">
        {remaining > 0
          ? `Encore ${remaining} vérification${remaining > 1 ? 's' : ''} avant de créer`
          : 'Tout est vérifié. Rien n’est créé avant ce clic.'}
      </p>
    </aside>
  )
}
